export const formatNumberWithDecimal = (num: number) => {
  if (num % 1 === 0) {
    return num.toFixed(0); // If num needs no decimal. ex: (23)
  } else if ((num * 10) % 1 === 0) {
    return num.toFixed(1); // If num needs 1 decimal. ex: (23.1)
  } else {
    return num.toFixed(2); // Two decimal places otherwise. ex: (23.34243) returns 23.34
  }
};
